require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-tschanigraben.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-tschanigraben");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-tschanigraben!./.cache/json/betreuungseinrichtungen-guessing-tschanigraben.json
// module id = 907
// module chunks = 231608221292675